export enum ListingType {
    Regular = 'regular',
    Special = 'special',
}
